import { render, staticRenderFns } from "./PettyCash.vue?vue&type=template&id=2ebfb401&scoped=true"
import script from "./PettyCash.vue?vue&type=script&lang=js"
export * from "./PettyCash.vue?vue&type=script&lang=js"
import style0 from "./PettyCash.vue?vue&type=style&index=0&id=2ebfb401&prod&lang=scss&scoped=true"
import style1 from "./PettyCash.vue?vue&type=style&index=1&id=2ebfb401&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ebfb401",
  null
  
)

export default component.exports